
import { AdminTitle } from '../../components';
import { PagamentosContainer } from './styles';

import { Icon } from '@iconify/react';

export const Pagamentos = () => {
  return (
    <>
      <PagamentosContainer>
        <AdminTitle title="Pagamentos" icon={<Icon icon="lucide:credit-card" />} />

        <div className='content-test'><h1>Tela de Pagamentos</h1></div>
      </PagamentosContainer>
    </>
  );
};
